import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Quote from "./pages/Quote";
import Contact from "./pages/Contact";
import Jobs from "./pages/Jobs";
import CookieBanner from "./pages/CookieBanner";



import {BrowserRouter ,Route ,Routes} from "react-router-dom"
function App() {
  return (
    <>
    <CookieBanner />
    <BrowserRouter>
    <Routes>
     <Route path="/" element={<Home /> }> </Route>
     <Route path="/About" element={<About /> }></Route>
     <Route path="/Services/:id" element={<Services />} />
     <Route path="/Quote" element={<Quote /> }></Route>
     <Route path="/Contact" element={<Contact /> }></Route>
     <Route path="/Career" element={<Jobs /> }></Route>
    
    
 
 
    
    </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
